import { UsuarioProvider } from './../providers/usuario.provider';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AlteracaoStatusRascunho } from '../models/alteracao-status-rascunho';
import { MensagemService } from '../pages/gestor/shared/services/mensagem.service';
import { BaseService } from './base.service';
import { GerenciadorCadastroEstabelecimentoService } from './modulo-cadastro/gerenciador-cadastro-estabelecimento.service';

@Injectable({
  providedIn: 'root',
})
export class RascunhoService {
  constructor(
    private http: HttpClient,
    private baseService: BaseService,
    private mensagemService: MensagemService,
    private gerenciadorCadastroService: GerenciadorCadastroEstabelecimentoService,
    private usuarioProvider :UsuarioProvider ,
  ) { }

  private itemDuplicadoCode = 422;

  async salvar(aba?): Promise<any> {
    // const estabelecimento = this.gerenciadorCadastroService.pegarEstabelecimento();
    // const rascunho = await this.gerenciadorCadastroService.montarRascunho();
    // const dados = {
    //     conteudo: rascunho.estabelecimentoPrincipal,
    //     statusRascunho: 'E',
    //     id: ''
    // };
    // if (!estabelecimento.codigoRascunho) {
    //     delete dados.id;
    //     await this.gerarCodigoRascunho(rascunho.estabelecimentoPrincipal);
    // }
    // dados.id = estabelecimento.codigoRascunho.toString();
    // if (aba === 'principal' && dados.id) {
    //     await this.salvarIdentificacaoPrincipal(dados.id, rascunho.estabelecimentoIdentificacaoPrincipal);
    // }
    // if (aba === 'complementar' && dados.id) {
    //     await this.salvarIdentificacaoComplementar(dados.id, rascunho.estabelecimentoIdentificacaoComplementar);
    // }
    // if (aba === 'endereco-complementar' && dados.id) {
    //     await this.salvarIdentificacaoEnderecoComplementar(dados.id, rascunho.estabelecimentoIdentificacaoEnderecoComplementar);
    // }
    // if (aba === 'caracterizacao-geral' && dados.id) {
    //     await this.salvarCaracterizacaoGeralRascunho(dados.id, rascunho.atividades);
    // }
  }

  async gerarCodigoRascunho(dadosPrincipal): Promise<any> {
    const url = environment.urlBaseNova + '/cnes/rascunhos';
    const response: any = await this.http.post(url, dadosPrincipal).toPromise();
    return response.record.id;
  }

  async salvarIdentificacaoPrincipal(
    codigoRascunho,
    estabelecimentoIdentificacaoPrincipal
  ): Promise<any> {
    try {
      if (!codigoRascunho) {
        return;
      }
      const url = `/cnes/rascunhos/${codigoRascunho}/identificacao-principal`;
      const response: any = await this.baseService.put(
        url,
        estabelecimentoIdentificacaoPrincipal
      );
      await this.mensagemService.showToast(
        'Identificação Principal salva com sucesso.'
      );
    } catch (e) {
      console.log('ERROR => ', e);
      await this.mensagemService.showToast(
        `Aconteceu um erro em salvar o rascunho, favor tentar mais tarde. ${e}`
      );
    } 
  }

  async salvarIdentificacaoComplementar(
    codigoRascunho,
    estabelecimentoIdentificacaoComplementar
  ): Promise<any> {
    try {
      if (!codigoRascunho) {
        return;
      }
      const url = `/cnes/rascunhos/${codigoRascunho}/identificacao-complementar`;
      const response: any = await this.baseService.put(
        url,
        estabelecimentoIdentificacaoComplementar
      );
      await this.mensagemService.showToast(
        'Identificação Complementar salva com sucesso.'
      );
    } catch (e) {
      await this.mensagemService.showToast(
        `Aconteceu um erro ao salvar o rascunho da identificação complementar, favor tentar mais tarde. ${e}`
      );
    } 
  }

  async salvarIdentificacaoEnderecoComplementar(
    codigoRascunho,
    estabelecimentoIdentificacaoEnderecoComplementar
  ): Promise<any> {
    let endereco: any = false;
    try {
      if (!codigoRascunho) {
        return;
      }
      const url = `${environment.urlBaseNova}/cnes/rascunhos/${codigoRascunho}/enderecos-complementares`;
      endereco = await this.http
        .post(url, estabelecimentoIdentificacaoEnderecoComplementar)
        .toPromise();
      await this.mensagemService.showToast(
        'Identificação complementar salva com sucesso'
      );
      await this.mensagemService.dismissLoading();
    } catch (e) {
      console.log('ERROR =>', e);
      throw e;
    }
    return endereco;
  }

  async alterarIdentificacaoEnderecoComplementar(
    codigoRascunho,
    codigoEndereco
  ): Promise<any> {
    const rascunho = await this.gerenciadorCadastroService.montarRascunho();
    this.alterarIdentificacaoEnderecoComplementarExec(
      codigoRascunho,
      codigoEndereco,
      rascunho.estabelecimentoIdentificacaoEnderecoComplementar
    );
  }

  async alterarIdentificacaoEnderecoComplementarExec(
    codigoRascunho,
    codigoEndereco,
    enderecoComplementar
  ): Promise<any> {
    let endereco: any = false;
    try {
      if (!codigoRascunho) {
        return;
      }

      const url =
        environment.urlBaseNova +
        '/cnes/rascunhos/' +
        codigoRascunho +
        '/enderecos-complementares/' +
        codigoEndereco;
      endereco = await this.http.put(url, enderecoComplementar).toPromise();
    } catch (e) {
      await this.mensagemService.showToast(
        `Aconteceu um erro ao alterar o rascunho da identificação complementar, favor tentar mais tarde. ${e}`
      );
      throw e;
    } finally {
      await this.mensagemService.dismissLoading();
    }
    return endereco;
  }

  async salvarCaracterizacaoGeralRascunho(
    codigoRascunho,
    caracterizacaoGeralRascunho
  ): Promise<any> {
      const url = `${environment.urlBaseNova}/cnes/rascunhos/${codigoRascunho}/caracterizacao`;
      return await this.http
        .put(url, caracterizacaoGeralRascunho)
        .toPromise();
  }


  async salvarRecursosFisicosEquipamentos(
    codigoRascunho,
    equipamentos
  ): Promise<any> {
    try {
      if (equipamentos.id) {
        const url =
          environment.urlBaseNova +
          '/cnes/rascunhos/' +
          codigoRascunho +
          '/equipamentos/' +
          equipamentos.id;
        await this.http.put(url, equipamentos).toPromise();
      } else {
        const url =
          environment.urlBaseNova +
          '/cnes/rascunhos/' +
          codigoRascunho +
          '/equipamentos';
        await this.http.post(url, equipamentos).toPromise();
      }
      await this.mensagemService.showToast(
        `Dados de equipamentos salvo com sucesso!`
      );
    } catch (e) {
      if (e.status === this.itemDuplicadoCode) {
        if (e.error && e.error.exceptions && e.error.exceptions[0] && e.error.exceptions[0].mensagem) {
          await this.mensagemService.showToast(e.error.exceptions[0].mensagem);
        } else {
          await this.mensagemService.showToast('Registro já existente');
        }
        return { skipCloseModal: true }
      } else {
        await this.mensagemService.showToast(
          `Aconteceu um erro em salvar os equipamentos, favor tentar mais tarde. ${e}`
        );
      }
    }
  }

  async salvarServicoCaracterizacao(codigoRascunho, servicos): Promise<any> {
    if (!codigoRascunho) {
      return;
    }
    const url = `${environment.urlBaseNova}/cnes/rascunhos/${codigoRascunho}/servicos-especializados`;
    if (servicos.id) {
      return await this.http.put(url + `/` + servicos.id, servicos).toPromise();
    }
    return await this.http.post(url, servicos).toPromise();
  }

  async salvarLeitoRecursosFisicos(
    codigoRascunho,
    leitoRecursos
  ): Promise<any> {
    const url = `/cnes/rascunhos/${codigoRascunho}/leitos`;
    if (leitoRecursos.id) {
      try {

        return await this.baseService.put(
          url + `/` + leitoRecursos.id,
          leitoRecursos
        );
      } catch (e) {
        if (e.status === this.itemDuplicadoCode) {
          const error = JSON.parse(e.error);
          if (error && error.exceptions && error.exceptions[0] && error.exceptions[0].mensagem) {
            await this.mensagemService.showToast(error.exceptions[0].mensagem);
          } else {
            await this.mensagemService.showToast(`Registro já existente`);
          }
          return { skipCloseModal: true, error: true }
        } else {
          await this.mensagemService.showToast(
            `Aconteceu um erro em salvar o leito, favor tentar mais tarde`
          );
          return { error: true }
        }
      }
    }
    try {
      return await this.baseService.post(url, leitoRecursos);
    } catch (e) {
      if (e.status === this.itemDuplicadoCode) {
        const error = JSON.parse(e.error);
        if (error && error.exceptions && error.exceptions[0] && error.exceptions[0].mensagem) {
          await this.mensagemService.showToast(error.exceptions[0].mensagem);
        } else {
          await this.mensagemService.showToast(`Registro já existente`);
        }
        return { skipCloseModal: true, error: true }
      } else {
        await this.mensagemService.showToast(
          `Aconteceu um erro em salvar o leito, favor tentar mais tarde`
        );
        return { error: true }
      }
    }
  }

  async salvarInstalacao(codigoRascunho, instalacao): Promise<any> {
    const url = `${environment.urlBaseNova}/cnes/rascunhos/${codigoRascunho}/instalacoes-fisicas`;
    if (instalacao.id) {
      return await this.http
        .put(url + `/` + instalacao.id, instalacao)
        .toPromise();
    }
    return await this.http.post(url, instalacao).toPromise();
  }

  async salvarProfissional(codigoRascunho, profissional): Promise<any> {
    if (!codigoRascunho) {
      return;
    }
    const url = `${environment.urlBaseNova}/cnes/rascunhos/${codigoRascunho}/profissionais`;
    if (profissional.id) {
      return await this.http
        .put(url + `/` + profissional.id, profissional)
        .toPromise();
    }
    return await this.http.post(url, profissional).toPromise();
  }

  async salvarEquipe(codigoRascunho, equipe): Promise<any> {
    if (!codigoRascunho) {
      return;
    }
    const url = `${environment.urlBaseNova}/cnes/rascunhos/${codigoRascunho}/equipes`;
    if (equipe.id) {
      return await this.http.put(url + `/` + equipe.id, equipe).toPromise();
    }
    return await this.http.post(url, equipe).toPromise();
  }

  async excluirRascunho(codigoRascunho) {
    if (!codigoRascunho) {
      return;
    }
    await this.baseService.delete('/cnes/rascunhos/' + codigoRascunho);
  }

  async consultarRascunho(codigoRascunho): Promise<any> {
    if (!codigoRascunho) {
      return;
    }
    const url = `${environment.urlBaseNova}/cnes/rascunhos/${codigoRascunho}`;
    const response: any = this.http.get(url).toPromise();
    return response;
  }

  gerarRelatorioOcorrencias(codigoRascunho) {
    if (!codigoRascunho) {
      return;
    }
    const url = `${environment.urlBaseNova}/cnes/rascunhos/${codigoRascunho}/relatorios-ocorrencias`;
    return this.http.post(url, undefined).toPromise();
  }

  getRelatorioOcorrencias(codigoRascunho) {
    if (!codigoRascunho) {
      return;
    }
    const url = `${environment.urlBaseNova}/cnes/rascunhos/${codigoRascunho}/relatorios-ocorrencias`;
    return this.http.get(url).toPromise();
  }

  getRelatorioOcorrenciasAlertas(idRascunho, idAnalise) {
    if (!idRascunho || !idAnalise) {
      return;
    }
    const url = `${environment.urlBaseNova}/cnes/rascunhos/${idRascunho}/relatorios-ocorrencias/alertas/${idAnalise}`;
    return this.http.get(url).toPromise();
  }

  private formatQueryParam(key?: string, value?: string) {
    if (!key || !value) {
      return '';
    }
    return `&${key}=${value}`
  }

  async listar(
    pageNumber: any = 0,
    pageSize: any = 5,
    conteudoLivre?: string,
    direcaoOrdenacao: string = 'DESC',
    atributoOrdenacao: string = 'CNES',
    status?: string,
  ): Promise<any> {
    let url =
      environment.urlBaseNova +
      '/cnes/rascunhos?pagina=' +
      pageNumber +
      '&tamanho-pagina=' +
      pageSize +
      '&direcao-ordenacao=' +
      direcaoOrdenacao +
      '&ordenacao=' +
      atributoOrdenacao +
      this.formatQueryParam(status ? 'status' : undefined, status);
    if (conteudoLivre && conteudoLivre.trim()) {
      url = url + '&conteudoLivre=' + conteudoLivre;
    }
    return await this.http.get(url).toPromise();
  }

  async listarMarcacoesPainel(
    pageNumber: any = 0,
    pageSize: any = 5,
    conteudoLivre?: string,
    direcaoOrdenacao: string = 'DESC',
    atributoOrdenacao: string = 'CNES'
  ): Promise<any> {
    const url =
      '/cnes/rascunhos?pagina=' +
      pageNumber +
      '&tamanho-pagina=' +
      pageSize +
      '&direcao-ordenacao=' +
      direcaoOrdenacao +
      '&ordenacao=' +
      atributoOrdenacao;

    // return await this.baseService.get(url).toPromise();
    return this.http.get('./assets/dados-fake/marcacoes.json').toPromise();
  }

  // tslint:disable-next-line:max-line-length
  async listarEquipesPainel(
    pageNumber: any = 0,
    pageSize: any = 5,
    conteudoLivre?: string,
    direcaoOrdenacao: string = 'DESC',
    atributoOrdenacao: string = 'CNES'
  ): Promise<any> {
    const url =
      '/cnes/rascunhos?pagina=' +
      pageNumber +
      '&tamanho-pagina=' +
      pageSize +
      '&direcao-ordenacao=' +
      direcaoOrdenacao +
      '&ordenacao=' +
      atributoOrdenacao;

    // return await this.baseService.get(url).toPromise();
    return this.http.get('./assets/dados-fake/equipes.json').toPromise();
  }

  // tslint:disable-next-line:max-line-length
  async listarProfissionaisPainel(
    pageNumber: any = 0,
    pageSize: any = 5,
    conteudoLivre?: string,
    direcaoOrdenacao: string = 'DESC',
    atributoOrdenacao: string = 'CNES'
  ): Promise<any> {
    const url =
      '/cnes/rascunhos?pagina=' +
      pageNumber +
      '&tamanho-pagina=' +
      pageSize +
      '&direcao-ordenacao=' +
      direcaoOrdenacao +
      '&ordenacao=' +
      atributoOrdenacao;

    // return await this.baseService.get(url).toPromise();
    return this.http.get('./assets/dados-fake/profissionais.json').toPromise();
  }

  async listarEquipamentosPainel(
    idRascunho: number,
    pageNumber: any = 0,
    pageSize: any = 5,
    conteudoLivre?: string,
    direcaoOrdenacao: string = 'DESC',
    atributoOrdenacao: string = 'EQUIPAMENTO'
  ): Promise<any> {
    let url =
      environment.urlBaseNova +
      '/cnes/rascunhos/' +
      idRascunho +
      '/equipamentos?pagina=' +
      pageNumber +
      '&tamanho-pagina=' +
      pageSize +
      '&direcao-ordenacao=' +
      direcaoOrdenacao +
      '&ordenacao=' +
      atributoOrdenacao;
    if (conteudoLivre) {
      url = url + '&conteudoLivre=' + conteudoLivre;
    }

    return await this.http.get(url).toPromise();
  }

  async listarInstalacoesFisicasPainel(
    idRascunho,
    pageNumber: any = 0,
    pageSize: any = 5,
    conteudoLivre?: string,
    direcaoOrdenacao: string = 'DESC',
    atributoOrdenacao: string = 'INSTALACAO'
  ): Promise<any> {
    const url =
      environment.urlBaseNova +
      '/cnes/rascunhos/' +
      idRascunho +
      '/instalacoes-fisicas?pagina=' +
      pageNumber +
      '&tamanho-pagina=' +
      pageSize +
      '&direcao-ordenacao=' +
      direcaoOrdenacao +
      '&ordenacao=' +
      atributoOrdenacao +
      '&conteudoLivre=' +
      conteudoLivre;

    return await this.http.get(url).toPromise();
  }

  async listarLeitosPainel(
    idRascunho: number,
    pageNumber: any = 0,
    pageSize: any = 5,
    conteudoLivre?: string,
    direcaoOrdenacao: string = 'DESC',
    atributoOrdenacao: string = 'CNES'
  ): Promise<any> {
    let url =
      environment.urlBaseNova +
      '/cnes/rascunhos/' +
      idRascunho +
      '/leitos?pagina=' +
      pageNumber +
      '&tamanho-pagina=' +
      pageSize +
      '&direcao-ordenacao=' +
      direcaoOrdenacao +
      '&ordenacao=' +
      atributoOrdenacao;
    if (conteudoLivre) {
      url = url + '&conteudoLivre=' + conteudoLivre;
    }
    return this.http.get(url).toPromise();
  }

  async listarServicosEspecializadosPainel(
    idRascunho,
    pageNumber: any = 0,
    pageSize: any = 5,
    conteudoLivre?: string,
    direcaoOrdenacao: string = 'DESC',
    atributoOrdenacao: string = 'INSTALACAO'
  ): Promise<any> {

    const url =
    environment.urlBaseNova +
    '/cnes/rascunhos/' +
    idRascunho +
    '/instalacoes-fisicas?pagina=' +
    pageNumber +
    '&tamanho-pagina=' +
    pageSize +
    '&direcao-ordenacao=' +
    direcaoOrdenacao +
    '&ordenacao=' +
    atributoOrdenacao +
    '&conteudoLivre=' +
    conteudoLivre;

    return await this.http.get(url).toPromise();
    
  }

  async gerarRascunho(codigoEstabelecimento) {
    const url = `${environment.urlBaseNova}/cnes/rascunhos/${codigoEstabelecimento}`;
    const response: any = this.http.get(url).toPromise();
    return response;
  }

  async pegarRascunho(codigoRascunho) {
    if (!codigoRascunho) {
      return;
    }
    const url = `${environment.urlBaseNova}/cnes/rascunhos/${codigoRascunho}`;
    const response: any = this.http.get(url).toPromise();
    return response;
  }

  async pegarRascunhoEnderecoPrincipal(codigoRascunho) {
    if (!codigoRascunho) {
      return;
    }
    const url = `/cnes/rascunhos/${codigoRascunho}/identificacao-principal`;
    const response: any = this.baseService.get(url).toPromise();
    return response;
  }

  async pegarRascunhoIdentificacaoComplementar(codigoRascunho) {
    if (!codigoRascunho) {
      return;
    }
    const url = `/cnes/rascunhos/${codigoRascunho}/identificacao-complementar`;
    const response: any = this.baseService.get(url).toPromise();
    // console.log('Response Identificação Complementar => ', response);
    return response;
  }

  async pegarRascunhoEnderecoComplementar(
    codigoRascunho,
    pageSize: any = 5,
    conteudoLivre?: string,
    pageNumber: number = 0,
    direcaoOrdenacao: string = 'DESC',
    atributoOrdenacao: string = 'NOME_REFERENCIA'
  ): Promise<any> {
    if (!codigoRascunho) {
      return;
    }
    let url =
      environment.urlBaseNova +
      '/cnes/rascunhos/' +
      codigoRascunho +
      '/enderecos-complementares?pagina=' +
      pageNumber +
      '&tamanho-pagina=' +
      pageSize +
      '&direcao-ordenacao=' +
      direcaoOrdenacao +
      '&ordenacao=' +
      atributoOrdenacao;
    if (conteudoLivre && conteudoLivre.trim()) {
      url = url + '&conteudoLivre=' + conteudoLivre;
    }
    return this.http.get(url).toPromise();
  }

  async pegarEnderecoComplementarPorid(codigoRascunho, id): Promise<any> {
    if (!codigoRascunho) {
      return;
    }
    let url = `${environment.urlBaseNova}/cnes/rascunhos/${codigoRascunho}/enderecos-complementares/${id}`;
    return this.http.get(url).toPromise();
  }

  async pegarRascunhoProfissional(
    codigoRascunho,
    pageNumber: any = 0,
    pageSize: any = 3,
    conteudoLivre?: string
  ) {
    if (!codigoRascunho) {
      return;
    }
    let url =
      `/cnes/rascunhos/${codigoRascunho}/profissionais?pagina=` +
      pageNumber +
      `&tamanho-pagina=` +
      pageSize;
    if (conteudoLivre && conteudoLivre.trim()) {
      url = url + '&conteudoLivre=' + conteudoLivre;
    }
    return this.baseService.get(url).toPromise();
  }

  async pegarRascunhoEquipamentos(
    idRascunho,
    pageNumber: any = 0,
    pageSize: any = 5,
    conteudoLivre?: string,
    direcaoOrdenacao: string = 'DESC',
    atributoOrdenacao: string = 'CNES'
  ): Promise<any> {
    let url = `${environment.urlBaseNova}/cnes/rascunhos/${idRascunho}/equipamentos?pagina=${pageNumber}&tamanho-pagina=${pageSize}&direcao-ordenacao=${direcaoOrdenacao}&ordenacao=${atributoOrdenacao}`;
    if (conteudoLivre) {
      url = url + '&conteudoLivre=' + conteudoLivre;
    }
    return this.http.get(url).toPromise();
  }

  async pegarRascunhoCaracterizacao(codigoRascunho) {
    if (!codigoRascunho) {
      return;
    }
    const url = `/cnes/rascunhos/${codigoRascunho}/caracterizacao`;
    const response: any = this.baseService.get(url).toPromise();
    return response;
  }

  async pegarRascunhoCaracterizacaoLeito(
    codigoRascunho,
    pageNumber: any = 0,
    pageSize: any = 5,
    conteudoLivre?: string
  ) {
    if (!codigoRascunho) {
      return;
    }
    let url =
      `/cnes/rascunhos/${codigoRascunho}/leitos?pagina=` +
      pageNumber +
      '&tamanho-pagina=' +
      pageSize;
    if (conteudoLivre && conteudoLivre.trim()) {
      url = url + '&conteudoLivre=' + conteudoLivre;
    }
    return await this.baseService.get(url).toPromise();
  }

  async pegarRascunhoRecursoInstalacoes(
    idRascunho,
    pageNumber: any = 0,
    pageSize: any = 5,
    conteudoLivre?: string,
    direcaoOrdenacao: string = 'DESC',
    atributoOrdenacao: string = 'CNES'
  ) {
    let url = `${environment.urlBaseNova}/cnes/rascunhos/${idRascunho}/instalacoes-fisicas?pagina=${pageNumber}&tamanho-pagina=${pageSize}&direcao-ordenacao=${direcaoOrdenacao}&ordenacao=${atributoOrdenacao}`;
    if (conteudoLivre) {
      url = url + '&conteudoLivre=' + conteudoLivre;
    }
    return await this.http.get(url).toPromise();
  }

  async pegarRascunhoCaracterizacaoServicos(
    codigoRascunho,
    conteudoLivre?: string,
    paginaAtual = 0,
    registrosPorPagina = 10,
    direcaoOrdenacao = 'ASC',
    ordenacao = 'PRESTADO_POR'
  ) {
    if (!codigoRascunho) {
      return;
    }
    let url = `${environment.urlBaseNova}/cnes/rascunhos/${codigoRascunho}/servicos-especializados?pagina=${paginaAtual}&tamanho-pagina=${registrosPorPagina}&direcao-ordenacao=${direcaoOrdenacao}&ordenacao=${ordenacao}`;
    if (conteudoLivre && conteudoLivre.trim()) {
      url = url + '&conteudoLivre=' + conteudoLivre;
    }
    return await this.http.get(url).toPromise();
  }

  async pegarRascunhoRecursoProfissionais(
    idRascunho,
    pageNumber: any = 0,
    pageSize: any = 5,
    conteudoLivre?: string,
    direcaoOrdenacao: string = 'DESC',
    atributoOrdenacao: string = 'CNS'
  ) {
    let url = `${environment.urlBaseNova}/cnes/rascunhos/${idRascunho}/profissionais?pagina=${pageNumber}&tamanho-pagina=${pageSize}&direcao-ordenacao=${direcaoOrdenacao}&ordenacao=${atributoOrdenacao}`;
    if (conteudoLivre) {
      url = url + '&conteudoLivre=' + conteudoLivre;
    }
    return await this.http.get(url).toPromise();
  }

  async getProfissionalRascunho(codigoRascunho, codigoProfissional) {
    if (!codigoRascunho && codigoProfissional) {
      return;
    }
    const url = `${environment.urlBaseNova}/cnes/rascunhos/${codigoRascunho}/profissionais/${codigoProfissional}`;
    const data = await this.http.get(url).toPromise();
    return data;
  }

  async pegarRascunhoRecursoEquipes(
    idRascunho,
    pageNumber: any = 0,
    pageSize: any = 5,
    conteudoLivre?: string,
    direcaoOrdenacao: string = 'DESC',
    atributoOrdenacao: string = 'CNS'
  ) {
    if (!idRascunho) {
      return;
    }
    let url = `/cnes/rascunhos/${idRascunho}/equipes?pagina=${pageNumber}&tamanho-pagina=${pageSize}&direcao-ordenacao=${direcaoOrdenacao}&ordenacao=${atributoOrdenacao}`;
    if (conteudoLivre && conteudoLivre.trim()) {
      url = url + '&conteudoLivre=' + conteudoLivre;
    }
    return await this.baseService.get(url).toPromise();
  }

  pegarRascunhoRecursoEquipe(idRascunho, idEquipe) {
    if (!idRascunho) {
      return;
    }
    let url = `/cnes/rascunhos/${idRascunho}/equipes/${idEquipe}`;
    return this.baseService.get(url).toPromise();
  }

  async listarServicosEspecializados() {
    const url = '/cnes/servicos';
    return await this.baseService.get(url).toPromise();
  }

  async excluirEnderecoComplementar(
    codigoRascunho: number,
    codigoEndereco: string
  ) {
    if (!codigoRascunho) {
      return;
    }
    await this.http
      .delete(
        environment.urlBaseNova +
        '/cnes/rascunhos/' +
        codigoRascunho +
        '/enderecos-complementares/' +
        codigoEndereco
      )
      .toPromise();
  }

  async excluirCaracterizacaoLeito(
    codigoRascunho: number,
    codigoLeito: string
  ) {
    if (!codigoRascunho) {
      return;
    }
    await this.baseService.delete(
      '/cnes/rascunhos/' + codigoRascunho + '/leitos/' + codigoLeito
    );
  }

  async excluirRecursoFisicoEquipamento(
    codigoRascunho: number,
    codigoEquipamento: string
  ) {
    if (!codigoRascunho) {
      return;
    }
    await this.baseService.delete(
      '/cnes/rascunhos/' + codigoRascunho + '/equipamentos/' + codigoEquipamento
    );
  }

  async excluirRecursoFisicoInstalacao(
    codigoRascunho: number,
    codigoInstalacao: string
  ) {
    if (!codigoRascunho) {
      return;
    }
    await this.http
      .delete(
        environment.urlBaseNova +
        '/cnes/rascunhos/' +
        codigoRascunho +
        '/instalacoes-fisicas/' +
        codigoInstalacao
      )
      .toPromise();
  }

  async excluirRecursoFisicoLeito(codigoRascunho: number, codigoLeito: string) {
    if (!codigoRascunho) {
      return;
    }
    await this.http
      .delete(
        environment.urlBaseNova +
        '/cnes/rascunhos/' +
        codigoRascunho +
        '/leitos/' +
        codigoLeito
      )
      .toPromise();
  }

  async excluirServicoCaracterizacao(
    codigoRascunho: number,
    codigoServico: string
  ) {
    await this.http
      .delete(
        `${environment.urlBaseNova}/cnes/rascunhos/${codigoRascunho}/servicos-especializados/${codigoServico}`
      )
      .toPromise();
  }

  async excluirProfissional(
    codigoRascunho: number,
    codigoProfissional: string
  ) {
    await this.http
      .delete(
        `${environment.urlBaseNova}/cnes/rascunhos/${codigoRascunho}/profissionais/${codigoProfissional}`
      )
      .toPromise();
  }

  async excluirEquipe(codigoRascunho: number, codigoEquipe: string) {
    await this.http
      .delete(
        `${environment.urlBaseNova}/cnes/rascunhos/${codigoRascunho}/equipes/${codigoEquipe}`
      )
      .toPromise();
  }

  async liberarEdicao(id, motivoDevolucao = '') {
    let url =
      environment.urlBaseNova + '/cnes/rascunhos/' + id + '/liberar-edicao';
    url = motivoDevolucao ? `${url}?motivoDevolucao=${motivoDevolucao}` : url;
    const response: any = await this.http
      .put(url, {
        idEstabelecimento: id,
      })
      .toPromise();
    return response;
  }

  async liberarAnalise(id, dadosUsuario: AlteracaoStatusRascunho) {
    const url =
      environment.urlBaseNova + '/cnes/rascunhos/' + id + '/liberar-analise';
    const response: any = await this.http.put(url, dadosUsuario).toPromise();
    return response;
  }

  async aprovarAtivar(id) {
    const url = environment.urlBaseNova + '/cnes/rascunhos/' + id + '/aprovar-ativar';
    const response: any = await this.http.put(url, {}).toPromise();
    return response;
  }

  async devolverCadastro(id, motivo = '') {
    let url =
      environment.urlBaseNova + '/cnes/rascunhos/' + id + '/devolver-cadastro';
    url = motivo ? `${url}?motivo-devolucao=${motivo}` : url;
    const response: any = await this.http
      .put(url, {
        idEstabelecimento: id,
      })
      .toPromise();
    return response;
  }

  async getInteracoes(idRascunho) {
    if (!idRascunho) {
      return;
    }
    const url = `${environment.urlBaseNova}/cnes/rascunhos/${idRascunho}/interacao`;
    return await this.http.get(url).toPromise();
  }

  async salvarInteracao(idRascunho, rascunhoForm) {
    if (!idRascunho) {
      return;
    }
    const url = `${environment.urlBaseNova}/cnes/rascunhos/${idRascunho}/interacao`;
    return await this.http.post(url, rascunhoForm).toPromise();
  }

  async atualizarInteracao(idRascunho, rascunhoForm) {
    if (!idRascunho) {
      return;
    }
    const url = `${environment.urlBaseNova}/cnes/rascunhos/${idRascunho}/interacao`;
    return await this.http.put(url, rascunhoForm).toPromise();
  }

  async deleteInteracao(idRascunho) {
    if (!idRascunho) {
      return;
    }
    const url = `${environment.urlBaseNova}/cnes/rascunhos/${idRascunho}/interacao`;
    return await this.http.delete(url).toPromise();
  }

  async getRascunhoEquipeByIdRascunho(idRascunho) {
    const url = `/cnes/rascunhos/${idRascunho}/equipes/lista`;
    return await this.baseService.get(url).toPromise();
  }


  async iniciarProcessamentoRelatorioOcorrencia(idRascunho) {
    const url = `${environment.urlBaseNova}/cnes/rascunhos/${idRascunho}/relatorios-ocorrencias/iniciar-processamento`;
    const usuario = this.usuarioProvider.getUsuario();
    const bodyObj = {} as any;
    bodyObj.cpfUsuarioNotificacao = usuario.cpf;
    return await this.http.post(url, bodyObj).toPromise();
  }


  async getEquipeRascunhobyProfissionalAndCbo(cpf, cbo, idRascunho, idEquipe) {
    const url = '/cnes/consulta/equipes/rascunho/lista-por-profissional?';
    const params = new URLSearchParams({
      cpf, cbo, idRascunho
    });
    if(idEquipe) {
      params.append('idEquipe', idEquipe);
    }
    return await this.baseService.get(url+params.toString()).toPromise();
  }


} 
